(function() { module.exports = window["React"]; }());